/* eslint-disable */
import Loadable from "react-loadable";
import { MainLoadingPlaceholder } from "./MainLoadingPlaceholder";
import React, { useState } from "react";
import { Redirect, useParams } from "react-router";
import { useBasicApi } from "./core/api/Api";
import { addNotification } from "./AppNotification";
import { LoginBox } from "./auth/LoginBox";
import { Button } from "./core/views/Button";
import { observer } from "mobx-react";
import { Auth } from "./auth/Auth";
import { GlobalContext } from "./GlobalContext";
import { computed } from "mobx";
import { Route, Switch } from "react-router-dom";
import { ServerErrorPage } from "./ServerErrorPage";
import { VerifyEmailView } from "./auth/VerifyEmailView";
import AcceptInviteView from "./auth/AcceptInviteView";
import { ForgotPasswordView } from "./auth/ForgotPasswordView";
import SignUp from "./auth/SingUp";
import ResetPasswordView from "./auth/ResetPassword";
import AzureMarketplace from "./auth/AzureMarketplace";
import AwsMarketplace from "./auth/AwsMarketplace";
import { NoLocalApiPage } from "./core/NoLocalApiPage";
import { TrialOverSadRobotPage } from "./core/views/TrialOverSadRobot";
import LoginView from "./auth/Login";
import { ErrorView } from "./core/api/ErrorView";
import { MainAsyncPlaceHolder } from "./MainAsyncPlaceHolder";

const AsyncAppRoutes = Loadable({
  loader: () => import("./routes/App" /* webpackChunkName: "main-routes" */),
  loading: MainAsyncPlaceHolder,
  delay: 0,
});

function VerificationRequired() {
  const { email } = useParams<{ email: string }>();
  const [loading, setLoading] = useState(false);
  const api = useBasicApi();
  const handleResendEmail = async () => {
    setLoading(true);
    try {
      await api.post(`signup/resend-verification/${email}`);
      addNotification({
        level: "success",
        title: "Re-Send Confirmation Email",
        message: "We've sent you another email. Please check your inbox in a few minutes.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <LoginBox header={<h1>Please confirm your email address</h1>}>
      <div style={{ paddingLeft: 32, paddingBottom: 24, textAlign: "left" }}>
        <p>
          We've sent you an email to <b>{decodeURIComponent(email)}</b> with a confirmation link.
        </p>
        <p>You can click on the button to get a new confirmation email.</p>
        <div style={{ textAlign: "center" }}>
          <Button type="primary" loading={loading} onClick={handleResendEmail}>
            Re-Send Email
          </Button>
        </div>
      </div>
    </LoginBox>
  );
}

function SqlakeRedirect() {
  if(process.env.REACT_APP_ENV_TYPE !== "prod") {
    return <SignUp />
  }
  window.location.replace("https://sqlake.upsolver.com/signup")
  return null;
}

@observer
export class AppRoutesContainer extends React.Component<{ auth?: Auth; errorStore: any }> {
  static contextType = GlobalContext;
  context!: React.ContextType<typeof GlobalContext>;

  @computed
  get _route(): any {
    const { authenticated, loading } = this.context.auth.authentication;
    if (window.location.pathname !== "/login" && loading) {
      return <MainLoadingPlaceholder />;
    }
    return authenticated ? (
      <AsyncAppRoutes />
    ) : (
      <Switch>
        <Route exact path="/server-error" component={ServerErrorPage} />
        <Route path="/verify/:id" component={VerifyEmailView} />
        <Route path="/accept-invite/:id" component={AcceptInviteView} />
        <Route path="/forgot-password" component={ForgotPasswordView} />
        {/*<Route strict path="/signup" component={SignUp} />*/}
        <Route strict path="/signup" component={SqlakeRedirect} />
        <Route strict path="/signup/:plan" component={SignUp} />
        <Redirect exact from="/signup/post/:plan" to="/" />
        <Route path="/reset-password/:id" component={ResetPasswordView} />
        <Route path="/azure-marketplace" component={AzureMarketplace} />
        <Route path="/marketplace" component={AwsMarketplace} />
        <Route path="/no-local-api/:reason?" component={NoLocalApiPage} />
        <Route path="/trial-over" component={TrialOverSadRobotPage} />
        <Route path="/login/:jwt" component={(props: unknown) => <LoginView {...props as any} />} />
        <Route path="/verification-required/:email" component={VerificationRequired} />
        <Route path="/login" component={LoginView} />
        <Route component={MainLoadingPlaceholder} />
      </Switch>
    );
  }

  render() {
    return (
      <>
        <ErrorView errorStore={this.props.errorStore} />
        {this._route}
      </>
    );
  }
}
